<!-- src/views/article/Article.vue -->
<template>
    <div class="layout">
     <!-- 上面导航 -->
      <div class="sidebat">
         <Sidebar ></Sidebar>
      </div>
      <!-- 中间内容 -->
      <div class="warpper">
    <!-- 缓存首页 -->
    <keep-alive>
      <router-view v-if="$route.name === 'article-List'" />
    </keep-alive>
    <!-- 不缓存其他页面 -->
    <router-view v-if="$route.name !== 'article-List'" />
  </div>
 
       <!-- 网页底部 -->
        <Footer></Footer>
    </div>
   </template>
   
   <script>
 import Sidebar from "@/views/layout/sidebar/Index.vue"
 import Footer from "@/views/layout/footer/Index.vue"
 
 
   export default {
     name: 'layoutIndex',  // 修改为多词的组件名称
     components: {
     Sidebar,
     Footer,
   },
   data() {
   return {
     isCollapse: false, // 根据需要设置初始值
   };
 },
 methods:{
   changeShow() {
     this.isCollapse = !this.isCollapse;
   }
 }
   }
   </script>
   
   <style>
 
 
   .small{
     padding-left: 64px;
     
   }
   </style>